import { render, staticRenderFns } from "./information-delete.view.vue?vue&type=template&id=9dba28e8&"
import script from "./information-delete.view.vue?vue&type=script&lang=ts&"
export * from "./information-delete.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports